import { render, staticRenderFns } from "./AttachmentTileGrid.vue?vue&type=template&id=2c0ec925&scoped=true&"
import script from "./AttachmentTileGrid.vue?vue&type=script&lang=js&"
export * from "./AttachmentTileGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ec925",
  null
  
)

export default component.exports